import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import {
  ConceptKind,
  ConceptStatus,
  useAddConceptMutation,
  useGetUserQuery,
  useUpdateConceptMutation,
  useUpdateSfdrStrategyMutation,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConceptInput',
  props: {
    value: { default: null },
    disabled: { type: Boolean, default: false },
    impactData: { default: undefined },
    impactGoalData: { default: undefined },
    conceptKind: { default: ConceptKind.Company },
    createdBy: { default: '' },
    sfdrStrategyId: { default: null }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: number | null): void
  (e: 'change', value: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number | null, disabled: boolean, impactData: Record<string, any>, impactGoalData: Record<string, any>, conceptKind: ConceptKind, createdBy: string, sfdrStrategyId: number | null };





const emitConceptId = (conceptId: number | null) => {
  emit('input', conceptId)
  emit('change', conceptId)
}

const { mutate: addConcept } = useAddConceptMutation()
const { mutate: updateConceptMutation } = useUpdateConceptMutation()
const { mutate: updateSfdrStrategy } = useUpdateSfdrStrategyMutation()
const { result: userResult } = useGetUserQuery()

const linkConceptToSfdrStrategy = async (conceptId: number | null) => {
  if (!conceptId || !props.sfdrStrategyId) return
  await updateSfdrStrategy({
    input: {
      id: props.sfdrStrategyId,
      conceptId,
    },
  })
}

const conceptLabel = computed(() => {
  const impactConceptLabel = props.impactData?.concept?.label
  if (impactConceptLabel) return impactConceptLabel
  const conceptId = props.value
  if (!conceptId) return ''
  return (
    props.impactGoalData?.impacts?.find((impact: any) => impact?.conceptId === conceptId)
      ?.concept?.label ?? ''
  )
})

const handleConceptChange = async (newLabel: string) => {
  if (props.disabled) return
  const trimmed = String(newLabel ?? '').trim()
  if (!trimmed) return
  if (!props.value) {
    const conceptResponse = await addConcept({
      input: {
        label: trimmed,
        status: ConceptStatus.Proposed,
        kind: props.conceptKind,
        createdBy:
          props.createdBy || userResult.value?.getUser?.email || '',
        sourceUrl: '',
        citation: '',
      },
    })
    const conceptId = conceptResponse?.data?.addConcept?.id ?? null
    await linkConceptToSfdrStrategy(conceptId)
    emitConceptId(conceptId)
    return
  }
  await updateConceptMutation({
    input: {
      id: props.value,
      label: trimmed,
    },
  })
  await linkConceptToSfdrStrategy(props.value)
  emitConceptId(props.value)
}

return { __sfc: true,props, emit, emitConceptId, addConcept, updateConceptMutation, updateSfdrStrategy, userResult, linkConceptToSfdrStrategy, conceptLabel, handleConceptChange }
}

})